import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { HelmetProvider } from "react-helmet-async";
import { RouterProvider } from "react-router-dom";
import GoogleTagManager from "@/components/GoogleTagManager";
import GDPRConsentBanner from "@/components/GDPRConsentBanner";
import { router } from "./router";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <HelmetProvider>
        <GoogleTagManager />
        <RouterProvider router={router} />
        <GDPRConsentBanner />
      </HelmetProvider>
    </QueryClientProvider>
  );
}

export default App;